<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="待办名称" prop="name">
              <el-input
                v-model="formParameter.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序" prop="priority"
              ><el-input
                placeholder="显示顺序"
                type="number"
                v-model="formParameter.priority"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12" v-if="!parameter.children">
            <el-form-item label="人日" prop="manDay"
              ><el-input
                placeholder="单位是天"
                min="0"
                type="number"
                v-model="formParameter.manDay"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remarks">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 3 }"
                v-model="formParameter.remarks"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="待办内容" prop="content">
              <wang-edit
                :isupdt="isUpdtWedit"
                v-model="formParameter.content"
              ></wang-edit>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/product/productBacklog/productBacklog.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
export default {
  name: "edit",
  components: {
    popup,
    wangEdit,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      productSelect: [],

      isUpdtWedit: false, //用于更新wangEdit

      rules: {
        //待办名称
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //优先级：数字越大优先级越低
        priority: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.range,
            min: "0",
            trigger: "blur",
          },
        ],
        //产品主键
        productId: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      console.log("打开弹框", this.parameter);

      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init(this.parameter.nxtId);
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.isUpdtWedit = true;
      this.formParameter = { content: "" };
      setTimeout(() => {
        this.isUpdtWedit = false;
      }, 100);
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          api.save(
            this.formParameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.$parent.reloadData(this.formParameter);
              this.close();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          //console.log("编辑",parameter)
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
    
              this.formParameter.index = this.parameter.index;
              this.formParameter.label = this.formParameter.name;
              this.$parent.reloadData(this.formParameter);
              this.close();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init(nxtId) {
      // let sss =  new Date().startDayOfWeek();
      // console.log("sss",sss.format("yyyy-MM-dd"))

      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = { manDay: "0", priority: nxtId };
      //清楚校验
      this.$refs.form.clearValidate();
      //将产品添加到表单中
      // this.formParameter.productId = localStorage.getItem('productId');
      this.formParameter.productId = this.$caches.pid.get();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;

          if (this.formParameter.content) {
            this.isUpdtWedit = true;
            setTimeout(() => {
              this.isUpdtWedit = false;
            }, 100);
          }

          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
        if (this.parameter.pid) {
          this.formParameter.pid = this.parameter.pid;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
